// PROSPECT website chatbot widget — self-contained vanilla JS.
// Injects its own styles and DOM and talks to the /api/chat Netlify function.
// Bundled into the site by Parcel via the <script> tag in index.html.

(function () {
  'use strict';

  // Endpoint exposed by netlify/functions/chat.mjs (config.path = '/api/chat').
  var API_URL = '/api/chat';

  // Bilingual UI strings — chosen from the browser language.
  var ja = document.documentElement.lang
    ? document.documentElement.lang.toLowerCase().indexOf('ja') === 0
    : (navigator.language || 'ja').toLowerCase().indexOf('ja') === 0;

  var T = ja
    ? {
        title: 'PROSPECT アシスタント',
        open: 'チャットを開く',
        close: '閉じる',
        placeholder: 'メッセージを入力…',
        send: '送信',
        greeting:
          'こんにちは。株式会社PROSPECTのアシスタントです。会社やサービスについてお気軽にお尋ねください。',
        error: '申し訳ございません。接続に問題が発生しました。時間をおいて再度お試しください。',
        thinking: '入力中…',
      }
    : {
        title: 'PROSPECT Assistant',
        open: 'Open chat',
        close: 'Close',
        placeholder: 'Type a message…',
        send: 'Send',
        greeting:
          "Hello! I'm PROSPECT's assistant. Ask me anything about the company or our automation services.",
        error: 'Sorry, something went wrong. Please try again in a moment.',
        thinking: 'Typing…',
      };

  // Conversation history sent to the backend (stateless server).
  var history = [];
  var busy = false;

  function injectStyles() {
    var css =
      '' +
      '.pb-launcher{position:fixed;right:20px;bottom:20px;z-index:9998;width:60px;height:60px;border-radius:50%;border:none;cursor:pointer;background:#0a7d4d;color:#fff;font-size:26px;box-shadow:0 6px 18px rgba(0,0,0,.25);transition:transform .15s ease}' +
      '.pb-launcher:hover{transform:scale(1.06)}' +
      '.pb-panel{position:fixed;right:20px;bottom:90px;z-index:9999;width:360px;max-width:calc(100vw - 40px);height:520px;max-height:calc(100vh - 120px);background:#fff;border-radius:14px;box-shadow:0 12px 40px rgba(0,0,0,.28);display:none;flex-direction:column;overflow:hidden;font-family:"Poppins",-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif}' +
      '.pb-panel.pb-open{display:flex}' +
      '.pb-header{background:#0a7d4d;color:#fff;padding:14px 16px;font-size:15px;font-weight:600;display:flex;justify-content:space-between;align-items:center}' +
      '.pb-header button{background:transparent;border:none;color:#fff;font-size:20px;cursor:pointer;line-height:1}' +
      '.pb-body{flex:1;overflow-y:auto;padding:14px;background:#f7f8fa;display:flex;flex-direction:column;gap:10px}' +
      '.pb-msg{max-width:85%;padding:9px 12px;border-radius:12px;font-size:14px;line-height:1.5;white-space:pre-wrap;word-wrap:break-word}' +
      '.pb-msg.user{align-self:flex-end;background:#0a7d4d;color:#fff;border-bottom-right-radius:4px}' +
      '.pb-msg.bot{align-self:flex-start;background:#fff;color:#1a1a1a;border:1px solid #e5e7eb;border-bottom-left-radius:4px}' +
      '.pb-msg.pending{opacity:.6;font-style:italic}' +
      '.pb-footer{display:flex;gap:8px;padding:10px;border-top:1px solid #eceef1;background:#fff}' +
      '.pb-footer textarea{flex:1;resize:none;border:1px solid #d7dbe0;border-radius:10px;padding:9px 11px;font-size:14px;font-family:inherit;max-height:96px;outline:none}' +
      '.pb-footer textarea:focus{border-color:#0a7d4d}' +
      '.pb-footer button{background:#0a7d4d;color:#fff;border:none;border-radius:10px;padding:0 16px;font-size:14px;cursor:pointer}' +
      '.pb-footer button:disabled{opacity:.5;cursor:not-allowed}';
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
  }

  var els = {};

  function buildUI() {
    var launcher = document.createElement('button');
    launcher.className = 'pb-launcher';
    launcher.setAttribute('aria-label', T.open);
    launcher.innerHTML = '💬';

    var panel = document.createElement('div');
    panel.className = 'pb-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', T.title);
    panel.innerHTML =
      '<div class="pb-header"><span>' +
      T.title +
      '</span><button class="pb-close" aria-label="' +
      T.close +
      '">×</button></div>' +
      '<div class="pb-body"></div>' +
      '<div class="pb-footer">' +
      '<textarea rows="1" placeholder="' +
      T.placeholder +
      '" aria-label="' +
      T.placeholder +
      '"></textarea>' +
      '<button class="pb-send">' +
      T.send +
      '</button></div>';

    document.body.appendChild(launcher);
    document.body.appendChild(panel);

    els.launcher = launcher;
    els.panel = panel;
    els.body = panel.querySelector('.pb-body');
    els.input = panel.querySelector('textarea');
    els.send = panel.querySelector('.pb-send');
    els.close = panel.querySelector('.pb-close');

    launcher.addEventListener('click', togglePanel);
    els.close.addEventListener('click', togglePanel);
    els.send.addEventListener('click', onSend);
    els.input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        onSend();
      }
    });
  }

  function togglePanel() {
    var opening = !els.panel.classList.contains('pb-open');
    els.panel.classList.toggle('pb-open');
    if (opening) {
      if (els.body.childElementCount === 0) addMessage('bot', T.greeting);
      els.input.focus();
    }
  }

  function addMessage(role, text, pending) {
    var div = document.createElement('div');
    div.className = 'pb-msg ' + (role === 'user' ? 'user' : 'bot') + (pending ? ' pending' : '');
    div.textContent = text;
    els.body.appendChild(div);
    els.body.scrollTop = els.body.scrollHeight;
    return div;
  }

  function onSend() {
    if (busy) return;
    var text = (els.input.value || '').trim();
    if (!text) return;

    els.input.value = '';
    addMessage('user', text);
    history.push({ role: 'user', content: text });

    busy = true;
    els.send.disabled = true;
    var pendingEl = addMessage('bot', T.thinking, true);

    fetch(API_URL, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ messages: history }),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (r) {
        if (!r.ok || !r.data || !r.data.reply) {
          throw new Error((r.data && r.data.error) || 'request failed');
        }
        pendingEl.classList.remove('pending');
        pendingEl.textContent = r.data.reply;
        history.push({ role: 'assistant', content: r.data.reply });
      })
      .catch(function () {
        pendingEl.classList.remove('pending');
        pendingEl.textContent = T.error;
        // Drop the failed user turn so history stays valid (must end on user).
        history.pop();
      })
      .finally(function () {
        busy = false;
        els.send.disabled = false;
        els.body.scrollTop = els.body.scrollHeight;
      });
  }

  function init() {
    injectStyles();
    buildUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
